import { createSelector } from "reselect"
import { get, keyBy, chain } from "lodash"
import { buildContributorKey } from "helpers/contributors"

const EMPTY_ARRAY = []
const EMPTY_OBJECT = {}

export const getRiskFactorsSummary = state => get(state, "global.data.riskFactors.data.model.simulation.risk.0", EMPTY_OBJECT)

// Contributors
const getRawContributorsFactors = state => get(state, "global.data.riskContributorsFactors.data.model.simulation.riskContributors", EMPTY_ARRAY)
const getRebalancedContributorsFactors = state => get(state, "modules.rebalance.rebalancedRiskContributors", EMPTY_ARRAY)

// Grouped Contributors
const getRawGroupedContributorsFactors = state => get(state, "global.data.groupedRiskContributorsFactors.data.model.simulation.groupedRiskContributors", EMPTY_ARRAY)
const getGroupedRebalancedContributorsFactors = state => get(state, "modules.rebalance.rebalancedGroupedRiskContributors", EMPTY_ARRAY)

export const getRiskContributorsFactors = createSelector(
  [getRawContributorsFactors],
  computeRiskContributorsFactors,
)

export const getGroupedRiskContributorsFactors = createSelector(
  [getRawGroupedContributorsFactors],
  computeRiskContributorsFactors,
)

export const getRebalancedRiskContributorsFactors = createSelector(
  [getRebalancedContributorsFactors],
  computeRiskContributorsFactors,
)

export const getGroupedRebalancedRiskContributorsFactors = createSelector(
  [getGroupedRebalancedContributorsFactors],
  computeRiskContributorsFactors,
)

function computeRiskContributorsFactors(contributors) {
  return chain(contributors)
    .keyBy(buildContributorKey)
    .mapValues((contributor) => ({
      factors: keyBy(contributor.attribution.factors, "id"),
      ...(contributor.contributors && { contributors: computeRiskContributorsFactors(contributor.contributors) }),
    }))
    .value()
}
